/**
 * there is a current issue with the boolean type in oazapfts
 * https://github.com/oazapfts/oazapfts/pull/638
 *
 * Basically it doesn't handle boolean yet,
 * A quick fix is to give a string instead of a boolean
 */
export function multipartBoolean(value: boolean): boolean {
  // fakeBoolean will be a string but we pretend it's a boolean
  const fakeBoolean = JSON.stringify(value) as any as boolean;

  return fakeBoolean;
}
